import React, { useState } from "react";
import axios from "axios";

export default function UploadForm({ setInsights, setStatementInfo  }) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      alert("Please select an Excel file");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await axios.post(
        "/api/upload-excel",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      console.log("AI RESPONSE:", res.data);

      // 🔑 Single source of truth
      setInsights(res.data.ai_insights);

      // send statement info (type + company name)
      setStatementInfo(res.data.ai_detection);

    } catch (err) {
      console.error(err);
      alert("Upload failed!");
    } finally {
      setLoading(false);
    }
  };

  return (
  <div className="card">
    <form onSubmit={handleSubmit} style={{ textAlign: "center" }}>
      <h3>Upload Financial Excel</h3>

      <input
        type="file"
        accept=".xlsx"
        onChange={(e) => setFile(e.target.files[0])}
        style={{ marginTop: "15px" }}
      />

      <div style={{ marginTop: "20px" }}>
        <button type="submit" disabled={loading} className="primary-btn">
          {loading ? "Analyzing..." : "Generate Insights"}
        </button>
      </div>

      {loading && (
        <p className="subtext" style={{ marginTop: "15px" }}>
          Reading data • Calculating KPIs • Asking Gemini 🤖
        </p>
      )}
    </form>
  </div>
);

}
